/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const t = "prevArrow.title", o = "nextArrow.title", e = "moreButtonTitle.title", r = {
  [t]: "Previous scroll button",
  [o]: "Next scroll button",
  [e]: "More button"
};
export {
  r as messages,
  e as moreButtonTitle,
  o as nextArrowTitle,
  t as prevArrowTitle
};
